"use client";

import { ZapCardTemplate } from "../ZapCard/ZapCard";
import { ZapCard } from "../ZapCard";
import { usePathname, useRouter } from "next/navigation";

export const ShowcaseCard = ({
  template,
  className,
}: {
  template: ZapCardTemplate;
  className?: string;
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const isLoggedIn = pathname?.includes("/app/");

  return (
    <ZapCard
      template={template}
      size="fullWidth"
      onClick={
        isLoggedIn
          ? null
          : () => router.push(`/templates/details/${template.slug}`)
      }
      className={className}
    />
  );
};
